/** @jsx jsx */
import { Fragment } from 'preact';
import { jsx, css } from '@emotion/react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import { useTheme, CacheProvider } from '../../../providers';
import { defaultBadgeComponentMap } from '../../../utilities';
import { useComponent } from '../../../hooks';
const CSS = {
    CalloutBadge: ({}) => css({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }),
};
export const CalloutBadge = observer((properties) => {
    const globalTheme = useTheme();
    const props = {
        // default props
        tag: 'callout',
        // global theme
        ...globalTheme?.components?.calloutBadge,
        // props
        ...properties,
        ...properties.theme?.components?.calloutBadge,
    };
    const { result, tag, renderEmpty, disableStyles, className, style } = props;
    const styling = {};
    const badgeComponentMap = { ...defaultBadgeComponentMap, ...props.componentMap };
    if (!disableStyles) {
        styling.css = [CSS.CalloutBadge(props), style];
    }
    else if (style) {
        styling.css = [style];
    }
    const limit = 1;
    const badges = result?.badges?.atLocation(tag).slice(0, limit);
    if (renderEmpty || badges?.length) {
        return (jsx(CacheProvider, null,
            jsx("div", { ...styling, className: classnames('ss__callout-badge', `ss__callout-badge--${tag?.replace('/', '-')}`, className) }, badges.map((badge) => {
                const BadgeComponent = useComponent(badgeComponentMap, badge.component);
                if (!BadgeComponent) {
                    return jsx(Fragment, null);
                }
                return jsx(BadgeComponent, { ...badge, ...badge.parameters });
            }))));
    }
    return jsx(Fragment, null);
});
